module.exports = __webpack_public_path__ + "static/media/BentonSans-Medium.afa06ec5.otf";